const coinSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24.28px"
	 height="22.789px" viewBox="0 0 24.28 22.789" enable-background="new 0 0 24.28 22.789" xml:space="preserve">
<g id="Layer_1">
	<g>
		<g>
			<path fill="#FFFFFF" d="M15.081,10.129c-0.458-0.379-1.157-0.593-2.161-0.656V5.961c0.979,0.046,1.398,0.305,1.398,1.741
				c0,0.317,0.312,0.574,0.697,0.574s0.699-0.257,0.699-0.574c0-2.45-1.449-2.831-2.795-2.892V3.867
				c0-0.318-0.312-0.574-0.696-0.574c-0.389,0-0.7,0.256-0.7,0.574v0.961C8.696,5.037,8.696,6.565,8.696,7.704v0.03
				c0,0.682,0,1.393,0.479,1.955c0.444,0.525,1.2,0.814,2.349,0.893v3.508c-0.953-0.05-1.362-0.318-1.362-1.738
				c0-0.314-0.312-0.574-0.697-0.574s-0.696,0.26-0.696,0.574c0,2.43,1.422,2.823,2.756,2.891v1.07c0,0.313,0.312,0.572,0.7,0.572
				c0.385,0,0.696-0.259,0.696-0.572v-1.076c0.999-0.066,1.69-0.279,2.153-0.66c0.676-0.559,0.672-1.316,0.668-2.049
				c0-0.123,0-0.249,0.002-0.371C15.748,11.43,15.754,10.686,15.081,10.129z M11.523,9.426c-0.62-0.051-1.026-0.183-1.205-0.396
				c-0.227-0.267-0.227-0.744-0.227-1.295v-0.03c0-1.087,0-1.614,1.432-1.728V9.426z M14.081,13.764
				c-0.196,0.163-0.593,0.27-1.161,0.316v-3.453c0.705,0.057,1.026,0.195,1.172,0.313c0.247,0.206,0.257,0.596,0.254,1.207v0.002
				c0,0.127,0,0.256,0,0.383C14.349,13.158,14.339,13.553,14.081,13.764z M14.348,11.891L14.348,11.891L14.348,11.891z"/>
			<path fill="#FFFFFF" d="M24.279,9.874C24.19,4.415,18.774,0,12.136,0C5.446,0,0,4.488,0,10.006c0,0.955,0.007,1.916,0.007,2.875
				c0,2.667,1.255,5.164,3.553,7.028c2.284,1.858,5.328,2.88,8.576,2.88c3.249,0,6.292-1.021,8.578-2.88
				c1.072-0.871,1.949-1.909,2.554-3.046c0.301-0.571,0.542-1.168,0.705-1.779c0.085-0.307,0.151-0.617,0.199-0.928
				s0.107-0.639,0.107-0.952V9.966C24.279,9.932,24.281,9.916,24.279,9.874z M4.309,18.869c-1.181-1.023-2.053-2.277-2.519-3.635
				c0.473,0.633,1.037,1.229,1.666,1.762C4.325,17.727,4.309,17.833,4.309,18.869z M7.798,20.895
				c-0.747-0.273-1.446-0.611-2.095-1.006v-1.402c0.665,0.338,1.368,0.629,2.095,0.857V20.895z M11.292,21.609
				c-0.722-0.045-1.422-0.148-2.098-0.307v-1.594c0.687,0.139,1.389,0.232,2.098,0.271V21.609z M14.784,21.367
				c-0.678,0.141-1.377,0.228-2.097,0.258v-1.627c0.712-0.029,1.41-0.105,2.097-0.23V21.367z M18.277,20.062
				c-0.649,0.372-1.352,0.683-2.096,0.931v-1.562c0.726-0.21,1.426-0.478,2.096-0.798V20.062z M19.671,19.111
				c0-0.287-0.122-1.175,0.086-1.323c1.04-0.745,2.001-1.583,2.725-2.554C21.979,16.701,20.996,18.047,19.671,19.111z
				 M22.749,11.357c-0.793,4.275-5.357,7.5-10.613,7.5c-5.257,0-9.819-3.225-10.611-7.5c-0.096-0.493-0.017-1.018-0.126-1.502
				c0.096-4.81,4.874-8.703,10.737-8.703c5.922,0,10.736,3.973,10.736,8.854C22.872,10.455,22.833,10.914,22.749,11.357z"/>
		</g>
	</g>
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids">
</g>
</svg>
`;

export default coinSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/coinSVG.js